import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import dayjs from 'dayjs';
import { AgentConversationSummary } from 'src/app/types/agent-chat';

/** The merchant's past support conversations, newest first; picking one reopens it. */
@Component({
  selector: 'app-agent-chat-history',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './agent-chat-history.component.html',
})
export class AgentChatHistoryComponent {
  readonly conversations = input<AgentConversationSummary[]>([]);
  readonly loading = input(false);
  readonly selected = output<string>();

  dateOf(date: string) {
    return dayjs(date).format('D MMM YYYY, HH:mm');
  }
}
